<template>
    <div class="checkout">
        <h1 class="checkout-title d-flex align-items-center">
            <button
                @click="setCheckout(false)"
                class="button button-icon mr-2"
            >
                <icon icon="arrow-left"/>
            </button>
            Bestelling afronden
        </h1>
        <form action="/checkout" method="post">
            <input type="hidden" name="items" :value="JSON.stringify(products)">
            <slot />

            <button
                :class="[{
                    disabled: !canOrderToday && checkoutDateIsToday,
                },'button']"
            >
                Betalen
            </button>
        </form>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapGetters } from 'vuex';

    import Icon from '@/components/ui/Icon';

    export default {
        name: 'CheckoutForm',
        components: {
            Icon,
        },
        computed: {
            ...mapState({
                products: state => state.cart.items,
            }),

            ...mapGetters('cart', [
                'canOrderToday',
                'checkoutDateIsToday',
            ]),
        },
        methods: {
            ...mapMutations({
                setCheckout: 'cart/setCheckout',
            }),
        },
    };
</script>

<style lang="scss">
    .checkout {
        &-title {
            margin-bottom: 42px;
            font-size: 30px;
        }

        &-section {
            margin-bottom: 24px;

            @include respond-to(md) {
                margin-bottom: 46px;
            }

            &-title {
                margin-bottom: 16px;
                font-size: 20px;
            }

            label {
                display: block;
                margin-bottom: 10px;
            }
        }
    }
</style>
